import React, { useState } from 'react'
import clsx from 'clsx'
import { RichTextField } from '../RichTextField/RichTextField'
import { TableOfContentProps } from './types'
import * as styles from './TableOfContent.module.css'

export function TableOfContent({ content, defaultOpen }: TableOfContentProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const toggleOpen = () => setIsOpen((prev) => !prev)

  return (
    <div className={styles.tableOfContent}>
      <summary
        className="mb-24 font-bold font-mulish list-none cursor-pointer text-bodyL text-text-dark-900"
        onClick={toggleOpen}
      >
        <i
          className={clsx(
            'fa text-grey-700 w-16 text-bodyXS bottom-12',
            isOpen ? 'fa-chevron-down' : 'fa-chevron-right'
          )}
        />{' '}
        On this page
      </summary>
      {isOpen && <RichTextField data={content} />}
    </div>
  )
}

export default TableOfContent
